import { render, staticRenderFns } from "./glFixTable.vue?vue&type=template&id=6f18c366"
import script from "./glFixTable.vue?vue&type=script&lang=js"
export * from "./glFixTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports